var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-required"},[_c('div',{staticClass:"help-required-title"},[_vm._v(_vm._s(_vm.$t('support required')))]),_c('div',{staticClass:"help-required-text"},[_vm._v(" "+_vm._s(_vm.$t('help contact support'))+" "),_c('a',{attrs:{"href":"mailto:support@cleanpro.app"}},[_vm._v("support@cleanpro.app")]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }